const LinkedInPublishSuccess = () => (
  <div style={{ padding: 20, background: "#e6f4ea", borderRadius: 6 }}>
    <h4>Post published successfully</h4>
    <p>Your post is now live on the LinkedIn Company Page.</p>
  </div>
);

export default LinkedInPublishSuccess;
